import React from 'react'
import { Paper } from '@mui/material'

const ContactUs = () => {
    return (
        <>
            <Paper>
                <div className='p-5'>

                    <div>
                        <h2>
                            Purbanchal Educational Welfare Society (PEWS)
                        </h2>
                    </div>
                    Purbanchal Educational Welfare Society (PEWS)
                    <br />
                    {/* Administrative Office: R.G. Baruah Road, Opp. Gauhati
                    <br />Commerce College Boy’s Hostel, Guwahati-3
                    <br /> */}
                    College Campus : Bonda Amgaon, Guwahati-781026
                    <br />

                    Phone : 88110 99994, 98640 91758, 98640 31785, 98640 16245,
                    <br />
                    Email: pewsghy@gmail.com
                </div>
            </Paper>

        </>
    )
}

export default ContactUs